// dependencies
import React from "react";
import { View, StyleSheet } from "react-native";

// components
import Stack from "../Stack";
import Heading from "@cloudspire/legacy-resources/src/components/Heading";
import Image from "@cloudspire/legacy-resources/src/components/Image";
import Text from "@cloudspire/legacy-resources/src/components/Text";

type PropsType = {
  title?: string;
  subtitle?: string;
  about?: string;
  content?: string;
  landscapeUri?: string;
};

const styles = StyleSheet.create({
  content: {},
});

const createMarkup = (content) => {
  return { __html: content };
};

const Content: React.FunctionComponent<PropsType> = (props) => {
  const { title, subtitle, about, content, landscapeUri } = props;

  return (
    <View style={[styles.content]}>
      {landscapeUri && (
        <>
          <Image source={{ uri: landscapeUri }} ratio={0.1875} alt={title} />
          <Stack marginBottom={0.75} />
        </>
      )}
      {title && (
        <>
          <Heading level={1} size={"xl"} textStyle={{ fontWeight: "500" }}>
            {title}
          </Heading>
        </>
      )}
      {subtitle && (
        <>
          <Heading level={2}>{subtitle}</Heading>
          <Stack marginBottom={0.75} />
        </>
      )}
      {about && (
        <>
          <Text>{about}</Text>
          <Stack marginBottom={0.75} />
        </>
      )}
      {content && (
        <>
          <Text>
            <div
              id="contentReset"
              dangerouslySetInnerHTML={createMarkup(content)}
            />
          </Text>
          <Stack marginBottom={0.75} />
        </>
      )}
    </View>
  );
};

export default Content;
